"use client";

import { c as _c } from "react/compiler-runtime";
interface RankingInfoTooltipProps {
  content: string;
  id: string;
}
const RankingInfoTooltip = t0 => {
  const $ = _c(6);
  const {
    content,
    id
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-[0_0_-1.41%_0] pointer-events-none" data-node-id="4734:14392" data-name="Background"><div className="absolute left-0 top-[6.08447265625px] h-[48.67605972290039px] w-full rounded-[4px] border border-gray-200 bg-white shadow-[0_1px_2px_rgba(0,0,0,0.05)]" /><div className="absolute left-[128px] top-0 h-[7.084507465362549px] w-[18.18532943725586px] [clip-path:polygon(50%_0,100%_100%,0_100%)] bg-gray-200" /><div className="absolute left-[129px] top-[1px] h-[6.084507465362549px] w-[16.18532943725586px] [clip-path:polygon(50%_0,100%_100%,0_100%)] bg-white" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== content) {
    t2 = <p className="absolute left-[12px] top-[14px] z-10 h-[32px] w-[245px] max-w-full [word-break:break-word] font-pretendard text-[12px] font-normal not-italic leading-[16px] text-black [text-shadow:0px_1px_2px_rgba(0,0,0,0.05)]" data-node-id="4734:14395">{content}</p>;
    $[1] = content;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== id || $[4] !== t2) {
    t3 = <div id={id} role="tooltip" className="absolute left-1/2 top-full z-20 mt-3 h-[54px] w-[269px] max-w-[calc(100vw-32px)] -translate-x-1/2 opacity-100" data-node-id="4742:11807" data-name="Tooltip">{t1}{t2}</div>;
    $[3] = id;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default RankingInfoTooltip;